<template>   
  <div class="cash-settings">
    <b-card body-class="py-2">
      <section class="list-view-heading">
        <ModuleViewHeading :module-id="Modules.FINANZAS" :profile-id="Profiles.PERSONAL" reference="settings" summary-only />
        <div class="list-view-heading__controls">
          <div class="list-view-heading__actions"><TabHeaderActions /></div>
          <div class="list-view-heading__controls-end">
            <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
            <b-button @click="show" type="button" variant="link" class="list-view-icon-btn" v-b-tooltip.hover.bottom title="Refrescar" aria-label="Refrescar"><AppIcon name="refresh" /></b-button>
            <b-button @click="add" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Agregar caja o cuenta" aria-label="Agregar caja o cuenta"><AppIcon name="add" /></b-button>
          </div>
        </div>
      </section>
      <b-collapse v-model="filtersOpen">
        <div class="list-view-toolbar__filters">
          <div class="cash-settings-status-filter"><label class="filter-label">Estado</label><b-form-radio-group v-model="filter.status" size="sm" buttons><b-form-radio value="all" button-variant="outline-secondary">Todas</b-form-radio><b-form-radio value="active" button-variant="outline-success">Activas</b-form-radio><b-form-radio value="inactive" button-variant="outline-danger">Inactivas</b-form-radio></b-form-radio-group></div>
        </div>
      </b-collapse>
    </b-card>
    <b-row class="mb-1">
      <b-col md="12">        
        <div class="cash-settings-policy-notice" v-if="parameters.freeAddTypeOperation"><span class="cash-settings-policy-notice__icon"><AppIcon name="tune" /></span><div><strong>Configuración general activa</strong><span>Esta configuración permite movimientos declarados y no declarados en una misma caja o cuenta.</span></div><span class="cash-settings-policy-notice__parameter">Parámetro 61</span></div>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="12">
        <b-table class="mb-0 app-table table-cash"
              responsive
              sticky-header="60vh"
              :hover="true"
              :stacked="isMobileViewport ? 'md' : false"
              :fixed="!isMobileViewport"
              :items="filteredItems"
              :fields="table.fields"
              :filter="table.filter"
              :current-page="table.currentPage"
              :per-page="table.perPage"
              :busy="table.isBusy"
              v-if="filteredItems.length">

          <template v-slot:cell(id)="data">
            <span class="font-size-15">
              <b>{{ data.item.id }}</b>
            </span>            
          </template>

          <template v-slot:cell(name)="data">
            <span class="font-size-15">
              <AppIcon name="share" class="mr-2" v-if="data.item.shared" v-b-tooltip.hover.bottom title="Caja o cuenta compartida" />
              <b>{{ data.item.name }}</b>
            </span>
            <div v-if="data.item.renders_to_cash_id" class="cash-renders-to">
                <AppIcon name="subdirectory_arrow_right" class="mr-1" />
              Rinde a: <strong>{{ (table.items.find(c => c.id === data.item.renders_to_cash_id) || {}).name || '—' }}</strong>
            </div>
          </template>

          <template v-slot:cell(configuration)="data">
            <div class="cash-settings-config-badges">
              <span class="cash-settings-config-chip" :class="data.item.nd ? 'cash-settings-config-chip--declared-off' : 'cash-settings-config-chip--declared'"><AppIcon :name="data.item.nd ? 'visibility_off' : 'verified'" /> {{ data.item.nd ? 'No declarada' : 'Declarada' }}</span>
              <span class="cash-settings-config-chip" :class="data.item.uncovered ? 'cash-settings-config-chip--uncovered' : 'cash-settings-config-chip--covered'"><AppIcon :name="data.item.uncovered ? 'account_balance' : 'shield'" /> {{ data.item.uncovered ? 'Con descubierto' : 'Sin descubierto' }}</span>
              <span class="cash-settings-config-chip" :class="data.item.only_open ? 'cash-settings-config-chip--opening' : 'cash-settings-config-chip--always'"><AppIcon :name="data.item.only_open ? 'lock' : 'all_inclusive'" /> {{ data.item.only_open ? 'Con apertura' : 'Siempre disponible' }}</span>
            </div>
          </template>

          <template v-slot:cell(cash_status)="data">
            <div class="cash-settings-status-cell">
              <span v-if="data.item.active" class="status-active"><AppIcon name="check_circle" /> Activa</span>
              <span v-else class="status-inactive"><AppIcon name="cancel" /> Inactiva</span>
              <span v-if="data.item.only_open && data.item.opening" class="cash-settings-operation-state cash-settings-operation-state--open"><AppIcon name="lock_open" /><span><strong>Abierta</strong><small><span v-html="statusCash(data.item)"></span></small></span></span>
              <span v-else-if="data.item.only_open" class="cash-settings-operation-state cash-settings-operation-state--closed"><AppIcon name="lock" /><span><strong>Cerrada</strong><small>Requiere apertura</small></span></span>
              <span v-else class="cash-settings-operation-state cash-settings-operation-state--always"><AppIcon name="all_inclusive" /><span><strong>Sin apertura</strong><small>Disponible siempre</small></span></span>
            </div>
          </template>

          <template v-slot:cell(active)="data">
            <span v-if="data.item.active" class="status-active">ACTIVA</span>
            <span v-else class="status-inactive">INACTIVA</span>
          </template>

          <template v-slot:cell(keyaccess)="data">
            <span v-if="data.item.keyaccess">
              <b>CTRL</b>+
              <b>SHIFT</b>+
              <b>{{ data.item.keyaccess }}</b>
            </span>
          </template>          

          <template v-slot:cell(nd)="data">
            <div v-if="!parameters.freeAddTypeOperation">
              <b-badge v-if="data.item.nd" variant="secondary">NO DECLARADA</b-badge>            
              <b-badge v-else variant="success">DECLARADA</b-badge>            
            </div>
            <div v-else>
              <b-badge variant="dark">AMBOS MOVIMIENTOS</b-badge>            
            </div>
          </template>          

          <template v-slot:cell(uncovered)="data">
            <b-badge v-if="data.item.uncovered" variant="success">DESCUBIERTO</b-badge>            
            <b-badge v-else variant="secondary">SIN DESCUBIERTO</b-badge>            
          </template>       

          <template v-slot:cell(only_open)="data">
            <b-badge v-if="data.item.only_open" variant="secondary">SOLO CON APERTURA</b-badge>            
            <b-badge v-else variant="success">ACEPTA SIEMPRE</b-badge>            
          </template>                 

          <template v-slot:cell(opening)="data">            
            <div v-if="data.item.only_open">
              <span v-if="data.item.opening" class="table-cash-status-open">
                <AppIcon name="lock_open" />
                ABIERTA (<span v-html="statusCash(data.item)"></span>)
              </span>            
              <span v-else class="table-cash-status-close">
                <AppIcon name="lock" />
                CERRADA
              </span>                        
            </div>
          </template>            

          <template v-slot:cell(amount_ars)="data">                        
            <span v-if="parseFloat(data.item.total_available_ars)>=0" class="cash-text-success">
              {{Intl.NumberFormat('es-AR',{style:'currency',currency: 'ARS'}).format(data.item.total_available_ars)}}
            </span>
            <span v-else class="cash-text-danger">
              ({{Intl.NumberFormat('es-AR',{style:'currency',currency: 'ARS'}).format(data.item.total_available_ars)}})
            </span>
          </template>          

          <template v-slot:cell(f_action)="data">
              <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'cash-settings-action-toggle-labeled' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }">
                <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                <b-dropdown-item @click="reOpenCash(data.item)" v-if="data.item.only_open && !data.item.opening && data.item.status.open">
                <AppIcon name="refresh" class="mr-1" /> Reabrir
              </b-dropdown-item>                  
              <b-dropdown-item @click="openCash(data.item)" v-if="data.item.only_open && !data.item.opening">
                <AppIcon name="lock_open" class="mr-1" /> Abrir
              </b-dropdown-item>
              <b-dropdown-item @click="closeCash(data.item)" v-if="data.item.only_open && data.item.opening">
                <AppIcon name="lock" class="mr-1" /> Cerrar
              </b-dropdown-item>          
              
              <b-dropdown-header>Movimientos</b-dropdown-header>   
              <b-dropdown-item @click="goDetail(data.item)">
                <AppIcon name="open_in_full" class="mr-1" /> Ver movimientos
              </b-dropdown-item>          

              <b-dropdown-header>Acciones</b-dropdown-header>                                                                         
              <b-dropdown-item @click="edit(data.item)">
                <AppIcon name="edit" class="mr-1" /> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="remove(data.item)">
                <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <EmptyState v-else icon="account_balance_wallet" title="No se encontraron cajas o cuentas" />
        <div class="app-table-footer cash-settings-table-footer" v-if="filteredItems.length"><span>{{ getRowCount(filteredItems) }} registros</span></div>
      </b-col>
    </b-row>
                        
    <b-row class="cash-settings-footer">
      <b-col>
        <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
          <AppIcon name="back" class="mr-1" />
          Volver
        </b-button>                        
      </b-col>

      <b-col>
        <nav>
          <b-pagination class="pull-right mb-0"
                        size="sm"
                        pills=""
                        :total-rows="getRowCount(filteredItems)"
                        :per-page="table.perPage"
                        v-model="table.currentPage" />
        </nav>
      </b-col> 
    </b-row>            

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <b-modal v-model="modal.form.active"
            body-class="cash-settings-modal-body"
            :key="modal.form._id"
            :id="modal.form._id">                
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon :name="crud.form.id ? 'edit' : 'add'" /></span><h5 class="app-modal-header__title">{{ modal.form.title }}</h5></div></template>

        <div class="cash-settings-policy-notice mb-3" v-if="parameters.freeAddTypeOperation"><span class="cash-settings-policy-notice__icon"><AppIcon name="tune" /></span><div><strong>Configuración general activa</strong><span>Los movimientos declarados y no declarados están habilitados para esta caja o cuenta.</span></div><span class="cash-settings-policy-notice__parameter">Parámetro 61</span></div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
          <b-tab no-body><template #title><AppIcon name="settings" class="mr-1" /> General</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Nombre" class="cash-settings-modal-name">
                  <b-form-input type="text"
                                  size="sm"
                                  v-model="crud.form.name"
                                  required>
                  </b-form-input>
                </b-form-group>
              </b-col>                    
              <b-col md="12">
                <div class="cash-settings-modal-section-title"><AppIcon name="tune" /> Operación y disponibilidad</div>
              </b-col>
              <b-col md="12" v-if="!parameters.freeAddTypeOperation">       
                <b-form-group label="Tipo" class="cash-settings-switch-field" description="Los movimientos solo pueden utilizarse desde un punto de venta no declarado.">
                  <b-form-checkbox v-model="crud.form.nd" 
                                    switch 
                                    size="sm">
                    NO DECLARADA
                  </b-form-checkbox>                      
                </b-form-group>      
              </b-col>            
              <b-col md="12">       
                <b-form-group label="Descubierto" class="cash-settings-switch-field" description="Permite que la caja o cuenta quede en descubierto.">
                  <b-form-checkbox v-model="crud.form.uncovered" 
                                    switch 
                                    size="sm">
                    ACEPTA DESCUBIERTO
                  </b-form-checkbox>                      
                </b-form-group>      
              </b-col>            
              <b-col md="12">       
                <b-form-group label="Apertura" class="cash-settings-switch-field" description="Los movimientos se aceptan únicamente después de abrir la caja.">
                  <b-form-checkbox v-model="crud.form.only_open" 
                                    switch 
                                    size="sm">
                    MOVIMIENTOS CON APERTURAS
                  </b-form-checkbox>                      
                </b-form-group>      
              </b-col>            
              <b-col md="12">
                <b-form-group label="Compartida" class="cash-settings-switch-field" description="Permite que todos los usuarios registren movimientos.">
                  <b-form-checkbox v-model="crud.form.shared"
                                    switch
                                    size="sm">
                    COMPARTIDA
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Rinde a (Caja principal)" class="cash-settings-select-field" description="Al abrir o cerrar, se registra el movimiento contra la caja principal elegida.">
                  <b-form-select v-model="crud.form.renders_to_cash_id" size="sm">
                    <b-form-select-option :value="null">— Sin rendición —</b-form-select-option>
                    <b-form-select-option
                      v-for="c in cajasParaRendicion"
                      :key="c.id"
                      :value="c.id">
                      {{ c.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab no-body><template #title><AppIcon name="visibility" class="mr-1" /> Visualización</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Estado" class="cash-settings-switch-field" description="La caja o cuenta queda disponible para operar.">
                  <b-form-checkbox v-model="crud.form.active"
                                    switch
                                    size="sm">
                    ACTIVA
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Mostrar en widgets" class="cash-settings-switch-field" description="La caja o cuenta aparece en los widgets del dashboard.">
                  <b-form-checkbox v-model="crud.form.show_in_widget"
                                    switch
                                    size="sm">
                    MOSTRAR EN WIDGETS
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Orden" class="cash-settings-select-field" description="Los valores menores aparecen primero.">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.order"
                                min="0"
                                step="1">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab no-body><template #title><AppIcon name="key" class="mr-1" /> Accesos</template>
            <b-row>
              <b-col lg="12">
                <b-form-group label="Acceso rápido" class="cash-settings-access-field">
                  <b-input-group size="sm" prepend="CTRL + SHIFT + ">
                    <b-form-input type="number" v-model="crud.form.keyaccess" min="0" max="9" step="1" @input="validateKeyAccess"></b-form-input>
                  </b-input-group>
                  <div class="cash-settings-access-hint"><AppIcon name="info" /><span>Ingresá un número del 0 al 9 para seleccionar esta caja desde Ventas o Ventas Rápidas. En Venta Mostrador la caja se selecciona automáticamente.</span></div>
                </b-form-group>
              </b-col>            
            </b-row>
          </b-tab>
          <b-tab no-body v-if="isProcessAccounting"><template #title><AppIcon name="account_balance" class="mr-1" /> Cuenta contable</template>
            <b-row>
              <b-col lg="12">
                <FindObject render="search"
                        type="accountingAccountsImputation" 
                        @select-object="loadAccountingAccounts($event)" 
                        :valueID="crud.form.accounting_accounts_id"
                        :where="conditionAccountingAccountsFilters"/>
              </b-col>              
            </b-row>            
          </b-tab>       

        </b-tabs>  

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
    </b-modal>    
  </div>
</template>

<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'
  import Param from '@/config/parameters'
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      ModuleViewHeading,
      TabHeaderActions,
    },          
    data: () => {
      return {      
        Modules,
        Profiles,
        access: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'settings',
          elements: {}
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 50,
          isBusy: false,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            nd: false,
            uncovered: false,
            only_open: false,
            accounting_accounts: null,
            accounting_accounts_id: 0,
            keyaccess: '',
            shared: false,
            renders_to_cash_id: null,
            active: true,
            order: 0,
            show_in_widget: true
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        modulesActive: [],
        parameters: {
          freeAddTypeOperation: false
        },
        filter: {
          status: 'active'
        },
        isMobileViewport: false,
        mobileMql: null,
        filtersOpen: false,
      }
    },
    created () {
      Helper.hasAccessView(this.access)
    },
    computed: {
      cajasParaRendicion() {
        return this.table.items.filter(c => c.id !== this.crud.form.id && c.active)
      },
      filteredItems() {
        if (this.filter.status === 'all') {
          return this.table.items;
        } else if (this.filter.status === 'active') {
          return this.table.items.filter(item => item.active);
        } else {
          return this.table.items.filter(item => !item.active);
        }
      },
      isProcessAccounting() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {
            status = true
          }
        })
        return status
      },
      // CONDITIONS SELECT
      conditionAccountingAccountsFilters(){
        return [
            {field: 'active', condition: true},
            {field: 'type', condition: 'Activo'}
        ];
      },              
    },
    mounted () {
      this.filtersOpen = Storage.getValue('filters_open_finances_settings') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.parameters.freeAddTypeOperation = Helper.hasParametersAccess(Param.P61)
      
      this.modulesActive = Session.getSession().auth.user.permissions.modules      
      this.show()

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.show()  
    },      
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_finances_settings', value ? 'true' : 'false')
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.loadFieldTable()
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        if(!this.isMobileViewport) {
          this.table.fields = [
            {key: 'id', label: 'ID', sortable: true, class:'align-middle text-center', width:'3%'},
            {key: 'name', label: 'Caja o cuenta', class:'align-middle', width:'26%'},
            {key: 'keyaccess', label: 'Acceso rápido', class:'align-middle', width:'10%'},
            {key: 'configuration', label: 'Configuración', class:'align-middle', width:'23%'},
            {key: 'cash_status', label: 'Estado', class:'align-middle', width:'20%'},
            {key: 'amount_ars', label: 'Saldo', class:'align-middle text-right', width:'15%'},
            {key: 'f_action', label:'', class:'align-middle', width:'3%'},
          ]
          return
        }
        this.table.fields = [
          {key: 'id', label: 'ID', sortable: true, class:'align-middle ' + this.alignClass('text-center'), width:'4%'},
          {key: 'name', label: 'Nombre', class:'align-middle', width:'12%'},
          {key: 'keyaccess', label: 'Acceso rápido', class:'align-middle', width:'8%'},
          {key: 'nd', label: 'Tipo', class:'align-middle', width:'12%'},
          {key: 'uncovered', label: 'Descubierto', class:'align-middle', width:'11%'},
          {key: 'only_open', label: 'Apertura', class:'align-middle', width:'11%'},
          {key: 'opening', label: this.isMobileViewport ? 'Estado de apertura' : '', class:'align-middle ' + this.alignClass('text-right'), width:'12%'},
          {key: 'active', label: 'Estado', class:'align-middle', width:'8%'},
          {key: 'amount_ars', label: 'Saldo', class:'align-middle ' + this.alignClass('text-right'), width:'12%'},
          {key: 'f_action', label:this.isMobileViewport ? 'Acción' : '', class:'align-middle', width:'3%'},
        ]
      },
      getRowCount (items) {
        return items.length
      },
      show() {        
        this.table.isBusy = true

        var result = serviceAPI.obtenerCajas()

        result.then((response) => {
          this.table.isBusy = false

          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });  
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.nd = false
        this.crud.form.uncovered = false
        this.crud.form.only_open = false
        this.crud.form.accounting_accounts = null
        this.crud.form.accounting_accounts_id = 0
        this.crud.form.keyaccess = ''
        this.crud.form.shared = false
        this.crud.form.renders_to_cash_id = null
        this.crud.form.active = true
        this.crud.form.order = 0
        this.crud.form.show_in_widget = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Caja/Cuenta"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.nd = item.nd
        this.crud.form.uncovered = item.uncovered
        this.crud.form.only_open = item.only_open
        this.crud.form.accounting_accounts = item.accounting_accounts
        this.crud.form.accounting_accounts_id = item.accounting_accounts_id
        this.crud.form.keyaccess = item.keyaccess
        this.crud.form.shared = item.shared
        this.crud.form.renders_to_cash_id = item.renders_to_cash_id || null
        this.crud.form.active = item.active
        this.crud.form.order = item.order
        this.crud.form.show_in_widget = item.show_in_widget

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Caja/Cuenta"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name

        this.confirmDialog('¿Desea eliminar la caja o cuenta “' + this.crud.form.name + '”?', {
          title: 'Eliminar caja o cuenta',
          icon: 'delete',
          danger: true,
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCaja(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.show()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])

        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      save() {
        let loader = this.$loading.show();

        if (this.crud.form.id) {
          var result = serviceAPI.editarCaja(this.crud.form);
        } else {
          var result = serviceAPI.agregarCaja(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.show()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      loadAccountingAccounts (object) {
        if(object){
          this.crud.form.accounting_accounts = object
          this.crud.form.accounting_accounts_id = object.id             
        } else {
          this.crud.form.accounting_accounts = null
          this.crud.form.accounting_accounts_id = 0
        }
      },      

      openCash(data) {
        this.confirmDialog('Se abrirá la caja o cuenta “' + data.name + '”. ¿Desea continuar?', {
          title: 'Apertura de Caja',
          icon: 'lock_open',
          okTitle: 'Abrir'
        })
        .then(value => {
          if (value) {          

            let loader = this.$loading.show();
            
            let result = serviceAPI.abrirCaja({
              "finances_cash_id": data.id
            });
            
            result.then((response) => {          
              loader.hide()
              this.show()
              this.$awn.success("Caja/Cuenta ABIERTA");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },
      closeCash(data) {
        this.confirmDialog('Se cerrará la caja o cuenta “' + data.name + '”. ¿Desea continuar?', {
          title: 'Cierre de Caja',
          icon: 'lock',
          okTitle: 'Cerrar'
        })
        .then(value => {
          if (value) {           
            let loader = this.$loading.show();
            
            let result = serviceAPI.cerrarCaja({
              "finances_cash_id": data.id
            });
            
            result.then((response) => {          
              loader.hide()
              this.show()
              this.$awn.success("Caja/Cuenta CERRADA");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })         
      },
      reOpenCash(data) {        
        this.confirmDialog('Se reabrirá el último cierre de la caja o cuenta “' + data.name + '”. ¿Desea continuar?', {
          title: 'Reapertura de Caja',
          icon: 'refresh',
          okTitle: 'Reabrir'
        })
        .then(value => {
          if (value) {          

            let loader = this.$loading.show();
            
            let result = serviceAPI.reAbrirCaja({
              "finances_cash_id": data.id
            });
            
            result.then((response) => {          
              loader.hide()
              this.show()
              this.$awn.success("Caja/Cuenta REABIERTA");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },

      statusCash(data) {
        let status = ''
        
        if(data.status.status == 'OPEN') {
          if(data.status.open) {
            status = moment(data.status.open).locale('es').fromNow()
          } else {
            status = moment().locale('es').fromNow()
          }
          
        }

        return status       
      },

      goDetail(data) {        
        this.$router.push({ 
          name: 'FinancesStaffCashDetail', 
          params: {
            finances_cash_id: data.id,
            date_start: data.status.open ? data.status.open : null,
          } 
        })
      },

      validateKeyAccess() {
        const value = this.crud.form.keyaccess;

        if (value < 0 || value > 9) {
          this.crud.form.keyaccess = '';
        }
      },      
    } 
  }
</script>
<style>
  .cash-settings-modal-body { padding: 16px 18px; }
  .cash-settings-modal-section-title { align-items: center; border-top: 1px solid var(--app-color-border); color: var(--app-color-text); display: flex; font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); gap: 6px; margin: 6px 0 10px; padding-top: 14px; }
  .cash-settings-modal-section-title .material-symbols-rounded { color: var(--app-color-primary); font-size: 18px; }
  .cash-settings-modal-name { background: var(--app-color-surface-subtle); border: 1px solid var(--app-color-border); border-radius: 7px; padding: 10px 12px; }
  .cash-settings-switch-field,
  .cash-settings-select-field { background: var(--app-color-surface); border: 1px solid var(--app-color-border); border-radius: 7px; margin-bottom: 8px; padding: 9px 12px; }
  .cash-settings-switch-field:hover,
  .cash-settings-select-field:hover { border-color: var(--app-color-info-border); }
  .cash-settings-switch-field legend,
  .cash-settings-select-field legend,
  .cash-settings-modal-name legend,
  .cash-settings-access-field legend { color: var(--app-color-text); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); margin-bottom: 2px; }
  .cash-settings-switch-field .form-text,
  .cash-settings-select-field .form-text { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); margin-bottom: 7px; }
  .cash-settings-switch-field .custom-control-label { color: var(--app-color-primary-active); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); }
  .cash-settings-access-field { background: var(--app-color-info-soft); border: 1px solid var(--app-color-info-border); border-radius: 8px; padding: 12px; }
  .cash-settings-access-hint { align-items: flex-start; color: var(--app-color-text-secondary); display: flex; font-size: var(--app-text-xs); gap: 6px; line-height: 1.4; margin-top: 9px; }
  .cash-settings-access-hint .material-symbols-rounded { color: var(--app-color-info); font-size: 17px; }
  @media (max-width: 575.98px) { .cash-settings-modal-body { padding: 14px; } }
</style>
<style scoped>
  .cash-text-success {
    color: var(--app-color-success);
    font-size: 15px;
    font-weight: bold;
  }
  .cash-text-danger {
    color: var(--app-color-danger);
    font-size: 15px;
    font-weight: bold;
  }
  .table-cash-status-open {
    align-items: center;
    color: var(--app-color-success);
    display: inline-flex;
    font-weight: var(--app-font-semibold);
    gap: 5px;
  }
  .table-cash-status-close {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: inline-flex;
    font-weight: var(--app-font-semibold);
    gap: 5px;
  }
  .status-active {
    color: var(--app-color-success);
    font-weight: var(--app-font-semibold);
  }
  .status-inactive {
    color: var(--app-color-danger);
    font-weight: var(--app-font-semibold);
  }
  .cash-renders-to {
    font-size: 0.78rem;
    color: var(--app-color-text-secondary);
    margin-top: 2px;
  }
  .cash-renders-to strong {
    color: var(--app-color-text);
  }
  .cash-settings-status-filter { display: grid; gap: 2px; }
  .cash-settings-policy-notice { align-items: center; background: var(--app-color-warning-soft); border: 1px solid var(--app-color-warning-border); border-radius: 8px; display: flex; gap: 10px; padding: 11px 12px; }
  .cash-settings-policy-notice__icon { align-items: center; background: var(--app-color-surface); border-radius: 50%; color: var(--app-color-warning); display: inline-flex; flex: 0 0 32px; height: 32px; justify-content: center; }
  .cash-settings-policy-notice__icon .material-symbols-rounded { font-size: 19px; }
  .cash-settings-policy-notice strong,
  .cash-settings-policy-notice div > span { display: block; }
  .cash-settings-policy-notice strong { color: var(--app-color-text); font-size: var(--app-text-sm); }
  .cash-settings-policy-notice div > span { color: var(--app-color-text-secondary); font-size: var(--app-text-sm); }
  .cash-settings-policy-notice__parameter { background: var(--app-color-surface); border-radius: 999px; color: var(--app-color-warning-hover); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); margin-left: auto; padding: 3px 8px; white-space: nowrap; }
  .cash-settings-table-footer { padding-right: 12px; }
  .cash-settings-footer { background: var(--app-color-surface); border: 1px solid var(--app-color-border-strong); box-shadow: 0 -2px 9px rgba(7, 58, 78, 0.08), 0 3px 10px rgba(7, 58, 78, 0.08); margin: 12px 0 0; padding: 8px 0; }
  .btn.cash-settings-action-toggle-labeled { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); height: auto !important; justify-content: flex-start; min-height: 0; padding: 0 !important; width: auto !important; }
  .btn.cash-settings-action-toggle-labeled:hover,
  .btn.cash-settings-action-toggle-labeled:focus { color: var(--app-color-primary) !important; text-decoration: underline; }
  .cash-settings-config-badges { display: flex; flex-wrap: wrap; gap: 5px; }
  .cash-settings-config-chip { align-items: center; border: 1px solid; border-radius: 5px; display: inline-flex; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); gap: 3px; padding: 3px 5px; }
  .cash-settings-config-chip .material-symbols-rounded { font-size: 14px; }
  .cash-settings-config-chip--declared { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .cash-settings-config-chip--declared-off { background: var(--app-color-surface-subtle); border-color: var(--app-color-border-strong); color: var(--app-color-text-secondary); }
  .cash-settings-config-chip--uncovered { background: var(--app-color-warning-soft); border-color: var(--app-color-warning-border); color: var(--app-color-warning-hover); }
  .cash-settings-config-chip--covered { background: var(--app-color-surface-subtle); border-color: var(--app-color-border); color: var(--app-color-text-secondary); }
  .cash-settings-config-chip--opening { background: var(--app-color-info-soft); border-color: var(--app-color-info-border); color: var(--app-color-info); }
  .cash-settings-config-chip--always { background: var(--app-color-primary-soft); border-color: var(--app-color-info-border); color: var(--app-color-primary-active); }
  .cash-settings-status-cell { display: grid; gap: 4px; }
  .cash-settings-status-cell .status-active,
  .cash-settings-status-cell .status-inactive { align-items: center; display: inline-flex; gap: 5px; }
  .cash-settings-operation-state { align-items: center; border: 1px solid; border-radius: 6px; display: inline-flex; gap: 6px; padding: 4px 6px; }
  .cash-settings-operation-state > .material-symbols-rounded { font-size: 18px; }
  .cash-settings-operation-state strong,
  .cash-settings-operation-state small { display: block; line-height: 1.15; }
  .cash-settings-operation-state strong { font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); }
  .cash-settings-operation-state small { font-size: 11px; margin-top: 1px; }
  .cash-settings-operation-state--open { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .cash-settings-operation-state--closed { background: var(--app-color-danger-soft); border-color: var(--app-color-danger-border); color: var(--app-color-danger); }
  .cash-settings-operation-state--always { background: var(--app-color-info-soft); border-color: var(--app-color-info-border); color: var(--app-color-info); }
  @media (max-width: 575.98px) {
    .cash-settings-policy-notice { align-items: flex-start; }
    .cash-settings-policy-notice__parameter { margin-left: 0; }
  }
</style>
